(() => {
  const active = new Set();
  const init = () => {
    active.forEach(state => {
      if (state.root.isConnected) return;
      state.observer.disconnect();
      state.visibility?.disconnect();
      state.bar?.remove();
      active.delete(state);
    });
    document.querySelectorAll('[data-is-full-product="true"]').forEach(root => {
      if (root.dataset.sfReady) return;
      root.dataset.sfReady = 'true';
      const form = root.querySelector('[data-product-form]');
      const main = form?.querySelector('[data-add-to-cart]');
      const bar = root.querySelector('[data-sf-purchase-bar]');
      const shortcut = bar?.querySelector('[data-sf-purchase-button]');
      const groups = [...root.querySelectorAll('[data-sf-required-option]')];
      const selected = group => group.querySelector('.product__chip.selected');
      const setText = (node, value) => { if (node && node.textContent !== value) node.textContent = value; };
      const sync = () => {
        groups.forEach(group => {
          const choice = selected(group);
          const label = group.closest('.product__option')?.querySelector('[data-selected-value-for-option]');
          setText(label, choice?.dataset.optionValue || group.dataset.sfPrompt);
          group.querySelectorAll('.product__chip').forEach(chip => {
            const pressed = String(chip === choice);
            if (chip.getAttribute('aria-pressed') !== pressed) chip.setAttribute('aria-pressed', pressed);
          });
        });
        if (!main) return;
        const label = main.querySelector('[data-add-to-cart-text]')?.textContent.trim() || '';
        if (main.getAttribute('aria-label') !== label) main.setAttribute('aria-label', label);
        if (!bar) return;
        const missing = groups.some(group => !selected(group));
        setText(shortcut, missing ? bar.dataset.chooseSize : label);
        shortcut.disabled = !missing && main.disabled;
        const price = root.querySelector('.product__meta [data-price]');
        if (price) setText(bar.querySelector('[data-sf-price]'), price.textContent.trim());
      };
      let visibility;
      if (bar && main) {
        document.body.appendChild(bar);
        bar.dataset.chooseSize = main.dataset.sfChooseSize;
        shortcut.addEventListener('click', () => {
          const missing = groups.find(group => !selected(group));
          if (missing) {
            missing.scrollIntoView({block:'center', behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
            const chip = [...missing.querySelectorAll('.product__chip')].find(node => !node.disabled && !node.classList.contains('disabled'));
            chip?.focus({preventScroll:true});
          } else if (!main.disabled) main.click();
        });
        visibility = new IntersectionObserver(entries => {
          bar.hidden = entries[0].isIntersecting;
          document.body.classList.toggle('sf-has-purchase-bar', !bar.hidden);
        });
        visibility.observe(main);
      }
      root.addEventListener('click', () => requestAnimationFrame(sync));
      root.addEventListener('change', () => requestAnimationFrame(sync));
      const observer = new MutationObserver(sync);
      observer.observe(root, {subtree:true, attributes:true, attributeFilter:['class','disabled'], childList:true, characterData:true});
      active.add({root,bar,observer,visibility});
      sync();
    });
    document.querySelectorAll('[data-sf-fit-link]').forEach(link => {
      if (link.dataset.sfReady) return;
      link.dataset.sfReady = 'true';
      const dialog = link.nextElementSibling;
      if (!dialog?.showModal) return;
      const close = () => dialog.close();
      link.addEventListener('click', event => {
        event.preventDefault();
        dialog.showModal();
        document.body.classList.add('sf-dialog-open');
      });
      dialog.querySelector('[data-sf-fit-close]').addEventListener('click', close);
      dialog.addEventListener('click', event => { if (event.target === dialog) close(); });
      dialog.addEventListener('close', () => { document.body.classList.remove('sf-dialog-open'); link.focus(); });
    });
    document.querySelectorAll('[data-sf-fit-dialog] [data-sf-size-charts]').forEach((chart,index) => {
      if (chart.dataset.sfReady) return;
      chart.dataset.sfReady = 'true';
      const tabs = [...chart.querySelectorAll('[data-tsg-tab]')];
      const panels = [...chart.querySelectorAll('[data-tsg-panel]')];
      const select = (tab,focus=false) => {
        tabs.forEach(item => {const on=item===tab;item.classList.toggle('is-active',on);item.setAttribute('aria-selected',String(on));item.tabIndex=on?0:-1;});
        panels.forEach(panel => {const on=panel.dataset.tsgPanel===tab.dataset.tsgTab;panel.classList.toggle('is-active',on);panel.hidden=!on;});
        if(focus)tab.focus();
      };
      tabs.forEach((tab,i) => {
        tab.setAttribute('role','tab');tab.id='sf-guide-'+index+'-tab-'+i;
        const panel=panels.find(panel=>panel.dataset.tsgPanel===tab.dataset.tsgTab);
        panel.id='sf-guide-'+index+'-panel-'+i;panel.setAttribute('role','tabpanel');panel.setAttribute('aria-labelledby',tab.id);tab.setAttribute('aria-controls',panel.id);
        tab.addEventListener('click',()=>select(tab));
        tab.addEventListener('keydown',event=>{let next;if(event.key==='ArrowRight')next=(i+1)%tabs.length;if(event.key==='ArrowLeft')next=(i+tabs.length-1)%tabs.length;if(event.key==='Home')next=0;if(event.key==='End')next=tabs.length-1;if(next!==undefined){event.preventDefault();select(tabs[next],true);}});
      });
      select(tabs[0]);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
  let pending = false;
  new MutationObserver(() => {
    if (pending) return;
    pending = true;
    requestAnimationFrame(() => { pending = false; init(); });
  }).observe(document.documentElement,{subtree:true,childList:true});
})();
